import FraseSeleccionAplicacionRow from "./FraseSeleccionAplicacionRow";

const FrasesSeleccionAplicacionTable = ({ frases, search }) => {
  return (
    <div className="table-responsive">
      <table className="table bordered-table mb-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Frase</th>
            <th>Estado</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {frases.map((frase) => (
            <FraseSeleccionAplicacionRow
              key={frase.id}
              frase={frase}
              search={search}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FrasesSeleccionAplicacionTable;
